'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.lastMessage = undefined;

var _getMessages = require('./getMessages');

var lastMessage = exports.lastMessage = function lastMessage(threadHistory) {
  return (0, _getMessages.getMessages)(threadHistory).last();
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/thread-history/operators/lastMessage.js
// module id = 754
// module chunks = 2 3